export enum AtmPartnerModel {
  Default = 0,
  Partner = 1,
  Investor = 2,
}
